import { render, staticRenderFns } from "./SpecialRequestsList.vue?vue&type=template&id=17942858&scoped=true"
import script from "./SpecialRequestsList.vue?vue&type=script&lang=js"
export * from "./SpecialRequestsList.vue?vue&type=script&lang=js"
import style0 from "./SpecialRequestsList.vue?vue&type=style&index=0&id=17942858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17942858",
  null
  
)

export default component.exports